import React, { useState } from 'react';

const Videotheque = () => {
  const [showAll, setShowAll] = useState(false);
  const videos = [
     { 
        src: '/videos/recolte_mais_bertoua.mp4', 
        caption:  'Chargement de notre récolte de maïs' 
      },
      { 
        src: '/videos/egrenage_mais.mp4', 
        caption:  'Égrenage du maïs fraîchement récolté' 
      },
      { 
        src: '/videos/truie_allerte.mp4', 
        caption: 'Truie appelant ses porcelets' 
      },
    { src: '/videos/mal_reproducteur.mp4', caption: 'Mâle reproducteur sélectionné par nos soins avec un rendement de 16 porcelets en moyenne' },
    { src: '/videos/lavage_truie.mp4', caption: 'Lavage de truies' },
    { src: '/videos/porcelets_nouvellement_sevres.mp4', caption: 'Porcelets nouvellement sevrés' },
    { src: '/videos/pepiniere_piment.mp4', caption: 'Pépinière piment' },
    { src: '/videos/porcelets_en_croissance.mp4', caption: 'Photo porcelets en croissance' },
    { src: '/videos/truie_maternelle.mp4', caption: 'Truie à caractères maternels exceptionnel' },
    { src: '/videos/porcelets_33jours_sous_mere.mp4', caption: 'Porcelets 33 jours sous mère' },
  ];


  return (
    <div>
        <section className="hero-section bg-light py-5">
            <div className="container text-center">
                <h1 className="display-4 fw-bold text-white">Découvrez notre univers en vidéo</h1>
                <p className="lead text-white">
                Plongez dans l'univers de K'MDEU FARMS à travers nos vidéos. Explorez nos exploitations, 
        découvrez nos méthodes de production et suivez notre engagement pour une agriculture durable.
                </p>
            </div>
        </section>
  <br></br>
      <div className="row">
      <h2>Notre monde en videos</h2>
        {(showAll ? videos : videos.slice(0, 12)).map((video, index) => (
          <div key={index} className="col-md-4 mb-4">
            <div className="video-container">
                <video controls className="fixed-size-video">
                <source src={video.src} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
            </div>
          <p>{video.caption}</p>
        </div>
        ))}
      </div>
      {videos.length > 2 && (
        <button className="btn btn-primary" onClick={() => setShowAll(!showAll)}>
          {showAll ? 'Afficher moins' : 'Afficher plus'}
        </button>
      )}
    </div>
  );
};

export default Videotheque;